import { Action } from '@ngrx/store';

import { RouterRequestActionType } from './router-request-action-type.enum';

export class RouterRequestError implements Action {
  public readonly type: RouterRequestActionType = RouterRequestActionType.RouterRequestError;

  constructor(public readonly payload: string) { }
}
